/*** Imports ***/

/* Style imports */
import './styles.css';

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';
/*** Component Import */

import Gutter from "../../../../../Gutter/Gutter";
import Content from "../../../../../../content/Content";
import TitleLogo from "../../../../../TitleLogo/TitileLogo";
import Section from "../Section/Section";
import SubSection from "../SubSection/SubSection";
import Constants from "../../../../../../constants/Constants";


/*** End Imports ***/

const DataBaseViewLeft = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div className="content-view-db-left">
            <div className="cv-left-1">
                <Gutter height={48}/>
                <p>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.HEADER}</p>
                <Gutter height={20}/>
            </div>
            <div className="cv-left-2">
                <div className="cvl2-left">
                    <Gutter height={19.5}/>
                    <TitleLogo
                        titleHeader={Content.DB_ACCESS_UPGRADE_INFO_POPUP.LEFT_SUB_HEADER}
                        srcIcon={Constants.ICONS.COINS_BLUE}
                        isActive
                        horizontal
                        imageStyle = {{
                            maxHeight: '19px',
                            maxWidth: '21px'
                        }}
                    />
                    <Gutter height={31.5}/>
                    <div className="cvl2-section">
                        <Section>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.COINS_SECTION_1}</Section>
                    </div>
                    <Gutter height={10}/>
                    <div className="cvl2-sub-section">
                        <SubSection>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.COINS_SUB_SECTION_1}</SubSection>
                    </div>
                    <Gutter height={30}/>

                    {/*2nd Line*/}
                    <div className="cvl2-section">
                        <Section>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.COINS_SECTION_2}</Section>
                    </div>
                    <Gutter height={10}/>
                    <div className="cvl2-sub-section">
                        <SubSection>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.COINS_SUB_SECTION_2}</SubSection>
                    </div>
                    {/*<Gutter height={30}/>*/}
                </div>
                <div className="cvl2-right">
                    <Gutter height={19.5}/>
                    <TitleLogo
                        titleHeader={Content.DB_ACCESS_UPGRADE_INFO_POPUP.RIGHT_SUB_HEADER}
                        srcIcon={Constants.ICONS.UNLOCK_BLUE}
                        isActive
                        horizontal
                        imageStyle={{
                            maxHeight: '19px',
                            maxWidth: '15px'
                        }}
                    />
                    <Gutter height={31.5}/>
                    <div className="cvl2-section">
                        <Section>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.DB_SECTION_1}</Section>
                    </div>
                    <Gutter height={10}/>
                    <div className="cvl2-sub-section">
                        <SubSection>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.DB_SUB_SECTION_1}</SubSection>
                    </div>
                    <Gutter height={30}/>
                    {/*2nd line*/}
                    <div className="cvl2-section">
                        <Section>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.DB_SECTION_2}</Section>
                    </div>
                    <Gutter height={10}/>
                    <div className="cvl2-sub-section">
                        <SubSection>{Content.DB_ACCESS_UPGRADE_INFO_POPUP.DB_SUB_SECTION_2}</SubSection>
                    </div>
                    {/*<Gutter height={30}/>*/}
                </div>
            </div>
            <div className="cvr2-no-profile">
                <div className="cvr2-no-profile-round-wrappper"><div className="cvr2-no-profile-round">1</div> = Rs. {props.rate ? props.rate : null}</div>
            </div>
        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
DataBaseViewLeft.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
DataBaseViewLeft.defaultProps ={

};

export default DataBaseViewLeft;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetDataBaseView/Component/DataBaseViewLeft/DataBaseViewLeft.js